export const SCALE_DEFINITIONS = {
  direct: { label: 'Solo vuelos directos' },
  one_scale: { label: '1 Escala' },
  two_or_more: { label: '2 o más escalas' },
};

const legMatches = (legScales, predicate) =>
  legScales.length > 0 && legScales.every(predicate);

export const scaleRules = {
  direct: legsScales =>
    legsScales.length > 0 &&
    legsScales.every(leg => legMatches(leg, s => s === 0)),

  one_scale: legsScales =>
    legsScales.length > 0 &&
    legsScales.every(leg => legMatches(leg, s => s <= 1)),

  two_or_more: () => true,
};

export const scaleRulesAvailable = {
  direct: legsScales =>
    legsScales.length > 0 && legsScales.every(leg => leg.includes(0)),

  one_scale: legsScales =>
    legsScales.length > 0 && legsScales.every(leg => leg.some(s => s <= 1)),

  two_or_more: legsScales => legsScales.some(leg => leg.includes(2)),
};
